<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:createByName="{ row }">
        <div>
          <span>{{ row.createByName }}</span>
          <br />
          <span>{{ row.createTime }}</span>
        </div>
      </template>
      <template v-slot:modifyByName="{ row }">
        <div>
          <span>{{ row.modifyByName }}</span>
          <br />
          <span>{{ row.modifyTime }}</span>
        </div>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.importTemplateStatus === '已启用' ? 'light' : 'warning'"
        >
          {{ row.importTemplateStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip class="item" effect="dark" content="查看" placement="top">
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'detail',
                  code: row.importTemplateCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
            v-allow="'actModify'"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'edit',
                  code: row.importTemplateCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            v-allow="'actDel'"
            placement="top"
            v-if="row.importTemplateStatus === '已启用'"
          >
            <i
              class="el-icon-delete tool-btn"
            v-if="row.importTemplateStatus === '已启用'"
              @click="del(row.importTemplateCode, '删除')"
            ></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(),
    }
  },
  methods: {
    del(code) {
      this.$confirm('确认要删除该记录吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.$api
          .sysOrderTemplateDelApi({ importTemplateCode: code })
          .then((res) => {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.$emit('reload')
          })
      })
    },
  },
}
</script>
